<template>
    <div>
        <h2>Formulaire utilisateur</h2>
        <div class="row">
            <div class="mb-3 col-md-6">
                <label for="name_user" class="form-label fw-bold">Nom*</label>
                <input type="text" class="form-control" id="name_user" placeholder="Nom" v-model="formData.name"
                    required>
                <small class="text-danger" v-if="errors['name']">{{ errors['name'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6">
                <label for="prenoms_user" class="form-label fw-bold">Prenoms</label>
                <input type="text" class="form-control" id="prenoms_user" placeholder="Prénoms"
                    v-model="formData.prenoms" required>
                <small class="text-danger" v-if="errors['prenoms']">{{ errors['prenoms'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6" v-if="!isEdit">
                <label for="telephone_user" class="form-label fw-bold">Téléphone*</label>
                <input type="text" class="form-control" id="telephone_user" placeholder="Téléphone"
                    v-model="formData.telephone" required>
                <small class="text-danger" v-if="errors['telephone']">{{ errors['telephone'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6">
                <label for="email_user" class="form-label fw-bold">Email*</label>
                <input type="text" class="form-control" id="email_user" placeholder="Email" v-model="formData.email"
                    required>
                <small class="text-danger" v-if="errors['email']">{{ errors['email'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6">
                <label for="adresse_user" class="form-label fw-bold">Adresse*</label>
                <input type="text" class="form-control" id="adresse_user" placeholder="Adresse"
                    v-model="formData.adresse" required>
                <small class="text-danger" v-if="errors['adresse']">{{ errors['adresse'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6">
                <label for="role_user" class="form-label fw-bold">Rôle</label>
                <select id="role_user" class="form-select" v-model="formData.role_id">
                    <option value="" selected disabled>-- Sélectionner un rôle --</option>
                    <option v-for="role in roles" :key="role.id" :value="role.id">
                        {{ role.long_name || role.name }}
                    </option>
                </select>
                <small class="text-danger" v-if="errors['role_id']">{{ errors['role_id'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6" v-if="!isEdit">
                <label for="password_user" class="form-label fw-bold">Mot de passe*</label>
                <div class="input-group">
                    <input :type="pwdShow ? 'text' : 'password'" class="form-control" id="password_user"
                        placeholder="Mot de passe" v-model="formData.password" required>
                    <span class="input-group-text" role="button" @click="pwdShow = !pwdShow">
                        <i v-if="!pwdShow" class="bi bi-eye"></i>
                        <i v-if="pwdShow" class="bi bi-eye-slash"></i>
                    </span>
                </div>
                <small class="text-danger" v-if="errors['password']">{{ errors['password'][0] }}</small>
            </div>

            <div class="mb-3 col-md-6" v-if="!isEdit">
                <label for="password_confirmation_user" class="form-label fw-bold">Confirmer le mot de passe*</label>
                <div class="input-group">
                    <input :type="pwdConfirmShow ? 'text' : 'password'" class="form-control" id="password_confirmation_user"
                        placeholder="Confirmer le mot de passe" v-model="formData.password_confirmation" required>
                    <span class="input-group-text" role="button" @click="pwdConfirmShow = !pwdConfirmShow">
                        <i v-if="!pwdConfirmShow" class="bi bi-eye"></i>
                        <i v-if="pwdConfirmShow" class="bi bi-eye-slash"></i>
                    </span>
                </div>
                <small class="text-danger" v-if="errors['password_confirmation']">{{ errors['password_confirmation'][0] }}</small>
            </div>
        </div>
        <div class="row">
            <div class="d-flex justify-content-end">
                <button class="btn btn-primary" @click="save">Enregistrer</button>
            </div>
        </div>
    </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';

export default {
    name: "UserForm",
    mixins: [formMixin],
    props: {
        user_id: {
            type: [String, Number],
            default: null
        }
    },
    data() {
        return {
            url: '/users',
            roles: [],
            pwdShow: false,
            pwdConfirmShow: false
        }
    },

    methods: {
        getRoles() {
            this.$api.get('/roles')
                .then(response => {
                    this.roles = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                })
        },
    },

    created() {
        this.getRoles();
    }


}
</script>